import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { MasterLoad } from 'src/app/domain/models/Pallet';

import { TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { FilterService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { ProfileContactInfo } from 'src/app/domain/models/Profile';
import { Router } from '@angular/router';
import { Routes } from 'src/app/infrastructure/routes';
import { Table } from 'primeng/table';
import { FilterLoadsUtils, MyLoadsFilter } from 'src/app/ui/util/custom-filters-my-loads';
import { BasicSelect } from 'src/app/ui/util/select-utils';


@Component({
  selector: 'app-user-load-master-orders',
  templateUrl: './user-load-master-orders.component.html',
  styleUrls: ['./user-load-master-orders.component.css'],

})
export class UserLoadMasterOrdersComponent {

  profile: ProfileContactInfo | undefined
  companyName: string = ""
  orders: LoadOrderListItem[] = []
  shipments: LoadOrderListItem[] = []
  searchTerm: string = '';

  masterLoads: MasterLoad[] = []

  loading: boolean = false
  year: number = new Date().getFullYear()

  filteredRegisters: MasterLoad[] = []
  containerFilter: SelectItem[] = []
  weekFilter: SelectItem[] = []
  importerFilter: SelectItem[] = []
  specieFilter: SelectItem[] = []
  varietyFilter: SelectItem[] = []
  shipFilter: SelectItem[] = []

  filter: MyLoadsFilter | undefined;
  selectedCompanies!: string[];
  selectedContainers!: string[];
  lang: string = 'en';
  yearSelect: number[] = []

  years: SelectItem[] = []

  profileUser: BasicUser | undefined


  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  constructor(
    private _router: Router,
    private _messageService: MessageService,
    private _palletService: PalletGateway,
    public translateService: TranslateService,
    private _authService: AuthGateway,
    private _profileService: ProfileService

  ) {
    if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
      this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
    }
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    let breadcrumbMenuItemLabel1 = 'Master view'
    let breadcrumbHomeMenuItemLabel = 'My loads'

    if(this.profileUser) {
      switch(this.profileUser.lang) {
        case 'en':
          breadcrumbMenuItemLabel1 = 'Master view'
          breadcrumbHomeMenuItemLabel = 'My loads'
          break
        case 'es':
          breadcrumbMenuItemLabel1 = 'Vista Master'
          breadcrumbHomeMenuItemLabel = 'Mis cargas'
          break
      }
    }

    this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
    this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrders };


    this.getYears()

    this.loadMaster()
    this.companyName = this._authService.getUser()?.companyName ?? ""
    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })
  }

  getYears() {
    let current = new Date()
    let currentYear = current.getFullYear()

    for(let i = 2023; i <= currentYear; i++) {
      this.years.push({label:i.toString(), value: i})
    }
  }

  filterLoads() {
    if (!this.searchTerm.trim()) {
      // Si el término de búsqueda está vacío, mostrar todos los pedidos
      this.filteredRegisters = this.masterLoads;
    } else {
      // Filtrar los pedidos basados en el término de búsqueda
      this.filteredRegisters = this.masterLoads.filter(product =>
        product.pallet.importOrderDetail.importOrder.sequence?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetailId.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.id.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.palletNumber.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        this.getTransportName(product.pallet.importOrderDetail.importOrder.transportType).toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportSpecies?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportVariety?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.producer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.speciesSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportHarvestDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportQualityControlDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportPackaging?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportPalletType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportTag?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBagType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBoxSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportNetWeight?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportFridgeStorage?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBoxesPerPallet?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportMark?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportContainerNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportGrade?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportTemptale?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportOriginCountry?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportLoadWeek?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.bl?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.booking?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.exportOffer?.exporter?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.exportOffer?.exporter?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.importOrder?.importer?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.importOrder?.importer?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.consigneeCompanyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.consigneeContactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.notifierCompanyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.notifierContactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.deliveryInstructions?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerCbm?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerTemperature?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeReceipt?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.departurePort?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.destinationPort?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.departureAirport?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.destinationAirport?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.week?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeDelivery?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.ship?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.voyageNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.typeMovement?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.oceanFreight?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.inland?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.localCharges?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.customs?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.surcharge?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.otherCosts?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.freightPayableAt?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeIssue?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.excessValueDeclaration?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    }
  }

  exportExcel(table: Table) {
    const tableExport = table.filteredValue ? table.filteredValue : this.filteredRegisters

    import('xlsx').then((xlsx) => {
      let sheets: any[] = []
      if(tableExport) {
        tableExport.forEach(x => {
          let row = {
            [this.translateTextExcel('ImportOrderIdHeader')]: x.pallet.importOrderDetail.importOrder.sequence,
            // [this.translateTextExcel('ImportDetailIdHeader')]: x.pallet.importOrderDetailId,
            // [this.translateTextExcel('ExportOrderIdHeader')]: x.pallet.importOrderDetail?.exportOffer?.id,
            // [this.translateTextExcel('PalletIdHeader')]: x.pallet.id,
            [this.translateTextExcel('FolioHeader')]: x.pallet.palletNumber,
            [this.translateTextExcel('TransportTypeHeader')]: this.getTransportName(x.pallet.importOrderDetail.importOrder.transportType),
            [this.translateTextExcel('SpecieHeader')]: x.pallet.excelImportSpecies,
            [this.translateTextExcel('VarietyHeader')]: x.pallet.excelImportVariety,
            [this.translateTextExcel('GrowerHeader')]: x.pallet.producer,
            [this.translateTextExcel('SpeciesSizeHeader')]: x.pallet.speciesSize,
            [this.translateTextExcel('HarvestDateHeader')]: x.pallet.excelImportHarvestDate,
            [this.translateTextExcel('QualityControlDateHeader')]: x.pallet.excelImportQualityControlDate,
            [this.translateTextExcel('PackagingHeader')]: x.pallet.excelImportPackaging,
            [this.translateTextExcel('PalletTypeHeader')]: x.pallet.excelImportPalletType,
            [this.translateTextExcel('LabelHeader')]: x.pallet.excelImportTag,
            [this.translateTextExcel('BagTypeHeader')]: x.pallet.excelImportBagType,
            [this.translateTextExcel('BoxSizeHeader')]: x.pallet.excelImportBoxSize,
            [this.translateTextExcel('NetWeightHeader')]: x.pallet.excelImportNetWeight,
            [this.translateTextExcel('FridgeStorageHeader')]: x.pallet.excelImportFridgeStorage,
            [this.translateTextExcel('BoxesPerPalletHeader')]: parseInt(x.pallet.excelImportBoxesPerPallet),
            [this.translateTextExcel('MarkHeader')]: x.pallet.excelImportMark,
            [this.translateTextExcel('ContainerNumberHeader')]: x.pallet.excelImportContainerNumber,
            [this.translateTextExcel('GradeHeader')]: x.pallet.excelImportGrade,
            [this.translateTextExcel('TemptaleHeader')]: x.pallet.excelImportTemptale,
            [this.translateTextExcel('OriginCountryHeader')]: x.pallet.excelImportOriginCountry,
            // [this.translateTextExcel('LoadingWeekHeader')]: x.pallet.excelImportLoadWeek,
            [this.translateTextExcel('BLNoHeader')]: x.delivery?.bl,
            [this.translateTextExcel('BookingNoHeader')]: x.delivery?.booking,
            [this.translateTextExcel('ContainerNoHeader')]: x.delivery?.containerNumber,
            [this.translateTextExcel('ExporterHeader')]: x.pallet.importOrderDetail?.exportOffer?.exporter?.companyName,
            [this.translateTextExcel('ExporterEmailHeader')]: x.pallet.importOrderDetail?.exportOffer?.exporter?.contactEmail,
            [this.translateTextExcel('ImporterHeader')]: x.pallet.importOrderDetail?.importOrder?.importer?.companyName,
            [this.translateTextExcel('ImporterEmailHeader')]: x.pallet.importOrderDetail?.importOrder?.importer?.contactEmail,
            [this.translateTextExcel('ConsigneeHeader')]: x.delivery?.consigneeCompanyName,
            [this.translateTextExcel('ConsigneeEmailHeader')]: x.delivery?.consigneeContactEmail,
            [this.translateTextExcel('NotifyHeader')]: x.delivery?.notifierCompanyName,
            [this.translateTextExcel('NotifyEmailHeader')]: x.delivery?.notifierContactEmail,
            [this.translateTextExcel('InstructionsHeader')]: x.delivery?.deliveryInstructions,
            [this.translateTextExcel('GrossWeight')]: x.delivery?.grossWeight,
            [this.translateTextExcel('CBM')]: x.delivery?.containerCbm,
            [this.translateTextExcel('Temperature')]: x.delivery?.containerTemperature,
            [this.translateTextExcel('PlaceReceipt')]: x.delivery?.placeReceipt,
            [this.translateTextExcel('OriginPort')]: x.delivery?.departurePort?.name,
            [this.translateTextExcel('DestinationPort')]: x.delivery?.destinationPort?.name,
            [this.translateTextExcel('OriginAirport')]: x.delivery?.departureAirport?.name,
            [this.translateTextExcel('DestinationAirport')]: x.delivery?.destinationAirport?.name,
            [this.translateTextExcel('Week')]: x.delivery?.week,
            [this.translateTextExcel('PlaceDelivery')]: x.delivery?.placeDelivery,
            [this.translateTextExcel('VesselName')]: x.delivery?.ship,
            [this.translateTextExcel('Voyage')]: x.delivery?.voyageNumber,
            [this.translateTextExcel('MovementType')]: x.delivery?.typeMovement,
            [this.translateTextExcel('ETD')]: x.delivery?.etd,
            [this.translateTextExcel('ETA')]: x.delivery?.eta,
            [this.translateTextExcel('OceanFreight')]: x.delivery?.oceanFreight,
            [this.translateTextExcel('Inland')]: x.delivery?.inland,
            [this.translateTextExcel('LocalCharges')]: x.delivery?.localCharges,
            [this.translateTextExcel('Customs')]: x.delivery?.customs,
            [this.translateTextExcel('Surcharge')]: x.delivery?.surcharge,
            [this.translateTextExcel('Others')]: x.delivery?.otherCosts,
            [this.translateTextExcel('FreightPayable')]: x.delivery?.freightPayableAt,
            [this.translateTextExcel('ShippedBoard')]: x.delivery?.shippedOnBoard,
            [this.translateTextExcel('IssuePlace')]: x.delivery?.placeIssue,
            [this.translateTextExcel('IssueDate')]: x.delivery?.dateIssue,
            [this.translateTextExcel('ExcessValue')]: x.delivery?.excessValueDeclaration,
            [this.translateTextExcel('PricePerBox')]: x.pallet.importOrderDetail?.price,
            [this.translateTextExcel('Incoterms')]: x.pallet.importOrderDetail?.incoterms,
          }
          sheets.push(row)
        })
      }
      const worksheet = xlsx.utils.json_to_sheet(sheets);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      // Aplica formato de 2 decimales a la columna de precios
      const range = xlsx.utils.decode_range(worksheet['!ref'] || '');
      for (let R = range.s.r + 1; R <= range.e.r; ++R) { // Salta el encabezado
        const cellAddress = xlsx.utils.encode_cell({ r: R, c: 59}); // Columna 63 (Precio)
        const cell = worksheet[cellAddress];
        if (cell && typeof cell.v === 'number') {
          cell.z =  '"$"#,##0.00_);\\("$"#,##0.00\\)';  // Formato de 2 decimales con signo de pesos
        }
      }

      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      let reportName = this.lang == 'es' ? 'Reporte Master' : 'Report Master';
      this.saveAsExcelFile(excelBuffer, reportName);
    });
  }

  translateTextExcel(text: string) {
    return this.translateService.instant(`UserPages.UserLoadMasterOrders.MainTable.${text}`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    let date = new Date()
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '-' + date.getDate()  + '-' + (date.getMonth() + 1) + '-' +date.getFullYear() + EXCEL_EXTENSION);
  }

  @ViewChild('loadMasterTable') dt: any;
  ngAfterContentInit(): void{
  }

  // Funcion para setear variables filtro
  configFilter()
  {

    this.filter = FilterLoadsUtils.getFilterConfig()

    if(this.filter)
    {
      if(this.filter.profileName)
      {
        this.selectedCompanies = [];
        this.selectedCompanies.push(this.filter.profileName)
        this.dt.filters['pallet.importOrderDetail.importOrder.importer.companyName'] = [
          {value: this.selectedCompanies, matchMode: "in"}
        ]
      }

      if(this.filter.container)
      {
        this.selectedContainers = [];
        this.selectedContainers.push(this.filter.container)
        this.dt.filters['delivery.containerNumber'] = [{value: this.selectedContainers, matchMode: "in"}]
      }

      if(this.filter.year)
      {
        this.year = this.filter.year;
      }

    }

    this.updateSelectedYear()
  }

  loadMaster(){
    this.loading = true;
    let config = FilterLoadsUtils.getFilterConfig()

    if(config){
      if(config.year){
        this.year = config.year
      }
    }

    this._palletService.getUserMasterLoad(this.year, false).subscribe({
      next: (v) => {
        this.loading = false;
        this.masterLoads = v
        this.filteredRegisters = v
        this.buildFilters(this.filteredRegisters)
        this.configFilter()
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los Master Loads.' });
      },
    })
  }

  filterTable(event: any) {
    let filterData  = event.filteredValue;
    this.buildFilters(filterData)
  }

  buildFilters(masterLoads: MasterLoad[] )
  {
    this.containerFilter = []
    this.weekFilter = []
    this.specieFilter = []
    this.shipFilter = []
    this.varietyFilter = []
    this.importerFilter = []

    masterLoads.forEach((item) => {
      if (item.delivery?.containerNumber && !this.containerFilter.some((x) => x.label == item.delivery.containerNumber )) {
        this.containerFilter.push({ label: item.delivery.containerNumber, value: item.delivery.containerNumber })
      }
      if (item.delivery?.week && !this.weekFilter.some( (x) => x.value === item.delivery.week)) {
        this.weekFilter.push({label :item.delivery.week.toString(), value: item.delivery.week} )
      }
      if (item.pallet.importOrderDetail?.importOrder?.importer?.companyName && !this.importerFilter.some(
        (x) => x.label === item.pallet.importOrderDetail?.importOrder?.importer?.companyName
      )) {
        this.importerFilter.push({ label: item.pallet.importOrderDetail?.importOrder?.importer?.companyName, value: item.pallet.importOrderDetail?.importOrder?.importer?.companyName })
      }
      if (item.pallet.excelImportSpecies && !this.specieFilter.some((x) => x.label === item.pallet.excelImportSpecies)) {
        this.specieFilter.push({label: item.pallet.excelImportSpecies, value: item.pallet.excelImportSpecies })
      }
      if (item.pallet.excelImportVariety && !this.varietyFilter.some( (x) => x.label === item.pallet.excelImportVariety)) {
        this.varietyFilter.push({label: item.pallet.excelImportVariety, value: item.pallet.excelImportVariety })
      }
      if (item.delivery?.ship && !this.shipFilter.some((x) => x.label === item.delivery?.ship)) {
        this.shipFilter.push({label: item.delivery?.ship, value: item.delivery?.ship} )
      }
    })

    this.weekFilter.sort((x) => x.value)
    this.containerFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.specieFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.shipFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.varietyFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.importerFilter.sort((a, b) => a.value.localeCompare(b.value))
  }

  getTransportName(transportType: number)
  {
    return TransportTypeUtils.getTransportName(this.translateService.currentLang, transportType);
  }

  goToLoadsPage(): void {
    this.clearFilters()
    this._router.navigate([Routes.userLoadOrders]);
  }

  clearFilters() {
    sessionStorage.removeItem("dt-masterload-session")
  }

  updateSelectedYear()
  {
    this.yearSelect = []
    this.yearSelect.push(this.year);
  }

  removeConfigFilter()
  {
    FilterLoadsUtils.removeFilterConfig()
  }

  searchLoadContainers(event: any)
  {
    this.removeConfigFilter()
    if(event.value.length > 0)
    {
      this.year = event.value[0]
      this.loadMaster()
    }else{
      this.masterLoads = []
      this.filteredRegisters = []
      this.yearSelect = []
    }
  }

}
